module.exports = __webpack_public_path__ + "static/media/revcarter.6d845381.svg";